import { mergeAttributes } from '@tiptap/core'
import { generateHTML } from '@tiptap/html';
import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'
import Mention from '@tiptap/extension-mention';
import TiptapLink from '@tiptap/extension-link';



export const CustomMention = Mention.extend({
  renderHTML({ node, HTMLAttributes }) {
    const slug = node.attrs.id.slug;
    return [
      'a',
      mergeAttributes({ 'data-type': this.name, 'href': `/company/${slug}`, 'target': '_blank', 'rel': 'noopener noreferrer' }, this.options.HTMLAttributes, HTMLAttributes),
      this.options.renderLabel({
        options: this.options,
        node,
      }),
    ]
  },
})

export const CustomParagraph = Paragraph.extend({
  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0]
  }
})


// This component will get tiptap body object and return generated html
const CustomBody = ({ body }) => {
  const generatedHtml = (body === null || body === "" || typeof body === "string" ) ? "" : generateHTML(body, [
    Document,
    CustomParagraph.configure({
      HTMLAttributes: {
        class: 'm-0',
      },
    }),
    Text,
    TiptapLink.configure({
      HTMLAttributes : {
          class: 'mds-text-primary'
      }
  }),
    CustomMention.configure({
      HTMLAttributes: {
        class: 'mention mds-text-primary',
      },
      renderLabel({ options, node }) {
        return `${options.suggestion.char}${node.attrs.id.companyName ?? node.attrs.id}`
      }
    }),
  ]);
``
  return (
    (body === null || body === "" ) ?
    <></>:
    <span dangerouslySetInnerHTML={{__html : generatedHtml}} />
  );
}

export default CustomBody;